import { el } from "date-fns/locale";
import {
  countCollection,
  createDoc,
  getFlutterTime,
  queryCollection,
} from "../models/DataFunctions";
import { dbHexamails } from "./FirebaseConfig";
import { updateDoc } from "firebase/firestore";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import sendHexamail from "../api/send/sendHexamail";
import { getOrRefreshFirebaseToken } from "./getFirebaseToken";

export const checkAndSendTriggerEvent = async (
  events,
  orgData,
  userData,
  prefix
) => {
  console.log("Checking trigger events: ", events);
  for (let event of events) {
    if (orgData.events_triggered && orgData.events_triggered[event]) {
      continue;
    } else {
      let verif = await verifyEventToTrigger(event, orgData, userData);
      console.log("Event: ", event, " verif: ", verif);
      if (verif === true) {
        await executeTriggerEmail(event, orgData, userData, prefix);
        return true;
      } else {
        continue;
      }
    }
  }
  return false;
};

export const executeTriggerEmail = async (event, orgData, userData, prefix) => {
  console.log("Executing trigger email for event: ", event);
  let filters = [
    {
      field: "event",
      operator: "==",
      value: event,
    },
  ];
  let email_templates = await queryCollection(
    "email_template",
    filters,
    1,
    null,
    null,
    dbHexamails
  );
  if (email_templates && email_templates.length > 0) {
    let email_template = email_templates[0];
    let html_content_with_variables = addVariablesToTemplate(
      email_template.body || "",
      userData,
      orgData
    );
    let subject_with_variables = addVariablesToTemplate(
      email_template.object || "",
      userData,
      orgData
    );
    let body = {
      to: userData.email,
      subject: subject_with_variables,
      html_content: html_content_with_variables,
      from_name: "William de Hexagone",
      from_email: "notifications@hexagone.expert",
      reply_to: "william@hexagone.expert",
      sent_at: getFlutterTime(),
      email_template_id: email_template.id,
      web_button_label: email_template.web_button_label,
      web_button_url: email_template.web_button_url,
      mobile_button_label: email_template.mobile_button_label,
      mobile_button_url: email_template.mobile_button_url,
      trigger_type: "event",
    };
    let new_doc = await createDoc("email_delivered", body, dbHexamails);
    const token = await getOrRefreshFirebaseToken();
    await sendHexamail(new_doc.id, token, prefix);
    await updateDocDataFieldApi(
      orgData.ref,
      `events_triggered.${event}`,
      true,
      prefix
    );
  }
};

export const addVariablesToTemplate = (template, userData, orgData) => {
  let result = template;
  if (userData) {
    result = result.replace("{{user_name}}", userData.display_name || "");
    result = result.replace("{{user_email}}", userData.email || "");
  }
  if (orgData) {
    result = result.replace("{{org_name}}", orgData.name || "");
    result = result.replace("{{org_id}}", orgData.id || "");
    result = result.replace("{{org_address}}", orgData.address || "");
  }
  return result;
};

export const verifyEventToTrigger = async (event, orgData, userData) => {
  if (!orgData || !userData) return false;
  if (event === "first_folder_created") {
    let filters = [
      {
        field: "master_id",
        operator: "==",
        value: orgData.id,
      },
    ];
    let folders = await countCollection("folder", filters);
    if (folders === 1) {
      return true;
    }
  } else if (event === "first_devis_created") {
    let filters = [
      {
        field: "org_id",
        operator: "==",
        value: orgData.id,
      },
    ];
    let devis = await countCollection("devis", filters);
    if (devis === 1) {
      return true;
    }
  } else if (event === "first_partner_created") {
    let filters = [
      {
        field: "masters",
        operator: "array-contains",
        value: orgData.id,
      },
    ];
    let partners = await countCollection("org", filters);
    if (partners === 1) {
      return true;
    }
  } else if (event === "first_payment_initiated") {
    let filters = [
      {
        field: "master_id",
        operator: "==",
        value: orgData.id,
      },
    ];
    let payments = await countCollection("payment", filters);

    if (payments === 1) {
      return true;
    }
  } else if (event === "first_event_created") {
    let filters = [
      {
        field: "master_id",
        operator: "==",
        value: orgData.id,
      },
    ];
    let events = await countCollection("event", filters);

    if (events === 1) {
      return true;
    }
  } else if (event === "first_attestation_generated") {
    return true;
  } else if (event === "first_document_signed") {
    return true;
  } else if (event === "first_member_invited") {
    return true;
  }
  return false;
};
